import { toast } from "react-toastify";
import {
    deleteDataFromApi,
    getDataFromApi,
    postDataFromApi,
    putDataFromApi,
} from "../../../../../services/commonServices";
import { BranchMasterUpdateApi, BranchMasterDeleteApi, BranchMasterCreateApi, BranchMasterGetApi } from "../../../../../services/api";

export const handleGetBranchMaster = async (EditRecordId, setFormData, status, setIsOverlayLoaders) => {
    try {
        setIsOverlayLoaders(true)
        const getBranchMaster = BranchMasterGetApi(EditRecordId);
        let res = await getDataFromApi(getBranchMaster)

        if (res.data.status === 200) {

            setFormData((prevFormData) => {
                return {
                    0: {
                        ...prevFormData[0],
                        ...res?.data,
                        brmaster_code: res?.data?.br_code,

                        fk_br_state: status === "View" ? res?.data?.state_name : res?.data?.fk_br_state,
                        fk_br_city: status === "View" ? res?.data?.city_name : res?.data?.fk_br_city,
                        fk_br_countryy: status === "View" ? res?.data?.country_name : res?.data?.fk_br_country,
                        fk_compid: status === "View" ? res?.data?.company_name : res?.data?.fk_compid,
                        br_stamp: res?.data?.br_stamp,
                        br_purchase_code: res?.data?.br_purchase_code,
                    },
                };
            });
        }
        else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        // console.log('errrr',error)
    }
    finally {
        setIsOverlayLoaders(false)
    }
}


// export const handleBranchMasterCreateUpdate = async (
//     formData,
//     handleSubmit,
//     setIsOverlayLoader,
//     navigate,
//     status,
//     isCustomPopup,
//     setIsCustomPopup,
//     setFormData,
//     section
// ) => {
//     try {
//         setIsOverlayLoader(true)
//         if (!isCustomPopup) {
//             let isValidate = handleSubmit();
//             if (!isValidate) {
//                 return false;
//             }
//         }
//         console.log("!!!",formData[0]?.br_stamp)
//         let payloadData = {
//             br_name: formData[0]?.br_name,
//             br_code: formData[0]?.brmaster_code,
//             br_address: formData[0]?.br_address,
//             fk_br_country: formData[0]?.fk_br_countryy,
//             fk_br_state: formData[0]?.fk_br_state,
//             fk_br_city: formData[0]?.fk_br_city,
//             br_gst_no: formData[0]?.br_gst_no,
//             br_postal_code: formData[0]?.br_postal_code,
//             br_phoneno: formData[0]?.br_phoneno,
//             br_email: formData[0]?.br_email,
//             fk_compid: formData[0]?.fk_compid,
//             br_stamp: formData[0]?.br_stamp,
//             br_invoice_branch_code: formData[0]?.br_invoice_branch_code,
//             br_invoice_code: formData[0]?.br_invoice_code,
//             br_branch_tally_code: formData[0]?.br_branch_tally_code,
//         };
//         // let res
//         // if (formData[0].br_id) {
//         //     const branchUpdateUrl = BranchMasterUpdateApi(formData[0].br_id);
//         //     res = await putDataFromApi(branchUpdateUrl, payloadData)

//         // } else {
//         //     res = await postDataFromApi(BranchMasterCreateApi, payloadData);
//         // }
//         // if (res?.data?.status === 200) {

//         //     toast.success(res?.data?.message, {
//         //         position: "top-right",
//         //         autoClose: 2000,
//         //         hideProgressBar: false,
//         //         closeOnClick: true,
//         //         pauseOnHover: true,
//         //         draggable: true,
//         //         progress: undefined,
//         //         theme: "light",
//         //     });

//         // } else {
//         //     toast.error(res.message, {
//         //         position: "top-right",
//         //         autoClose: 2000,
//         //         hideProgressBar: false,
//         //         closeOnClick: true,
//         //         pauseOnHover: true,
//         //         draggable: true,
//         //         progress: undefined,
//         //         theme: "light",
//         //     });
//         // }
//     }
//     catch (ex) {
//         console.log('---', ex)
//     }
//     finally {
//         setIsOverlayLoader(false)
//         navigate("/branchList")
//     }
// }

const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        if (!file) {
            resolve("");
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            resolve(reader.result); // base64 STRING
        };

        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const handleBranchMasterCreateUpdate = async (
    formData,
    handleSubmit,
    setIsOverlayLoader,
    navigate,
    status,
    isCustomPopup,
    setIsCustomPopup,
    setFormData,
    section
) => {
    try {
        setIsOverlayLoader(true);

        if (!isCustomPopup) {
            let isValidate = handleSubmit();
            if (!isValidate) {
                return false;
            }
        }
        const brStampValue =
            formData[0]?.br_stamp instanceof File
                ? formData[0].br_stamp.name // ✅ STRING under 1100 chars
                : formData[0]?.br_stamp || "";

        let payloadData = {
            br_name: formData[0]?.br_name,
            br_code: formData[0]?.brmaster_code,
            br_address: formData[0]?.br_address,
            fk_br_country: formData[0]?.fk_br_countryy,
            fk_br_state: formData[0]?.fk_br_state,
            fk_br_city: formData[0]?.fk_br_city,
            br_gst_no: formData[0]?.br_gst_no,
            br_purchase_code: formData[0]?.br_purchase_code,
            br_postal_code: formData[0]?.br_postal_code,
            br_phoneno: formData[0]?.br_phoneno,
            br_email: formData[0]?.br_email,
            fk_compid: formData[0]?.fk_compid,
            br_stamp: brStampValue,
        };
        let res
        if (formData[0].br_id) {
            const branchUpdateUrl = BranchMasterUpdateApi(formData[0].br_id);
            res = await putDataFromApi(branchUpdateUrl, payloadData)

        } else {
            res = await postDataFromApi(BranchMasterCreateApi, payloadData);
        }
        if (res?.data?.status === 200) {

            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            navigate("/branchList");
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }


    catch (ex) {
        console.log("---", ex);
    } finally {
        setIsOverlayLoader(false);
        
    }
};


export const handleBranchMasterDelete = async (
    row,
    setIsDelete,
    getAllListingData,
    setPopupIndex

) => {
    try {
        let res
        let payloadData = {
            ...row,
            is_active: false
        };
        const branchUpdateUrl = BranchMasterUpdateApi(row?.br_id);
        res = await putDataFromApi(branchUpdateUrl, payloadData)

        // let res = await putDataFromApi(deletebranchUpdatedApi, payload);
        if (res?.data?.status === 200) {
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            getAllListingData();
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    catch (ex) { }
    finally {
        setIsDelete(false);
        setPopupIndex(-1);
    }


}